// extracted by mini-css-extract-plugin
module.exports = {"cursor":"EnteringTextAnimation_cursor__18K7-","blinking":"EnteringTextAnimation_blinking__2YrR2","blink":"EnteringTextAnimation_blink__BUM9a"};